import { FC, ReactNode } from 'react';
import { RawIntlProvider } from 'react-intl';
import { ThemeProvider } from 'styled-components';
import type { IntlShape } from 'react-intl';
import type { DefaultTheme } from 'styled-components';

interface AppContextProps {
  intl: IntlShape;
  themeContext: DefaultTheme;
  children?: ReactNode;
}

const AppContext: FC<AppContextProps> = ({ intl, themeContext, children }) => {
  return (
    <RawIntlProvider value={intl}>
      <ThemeProvider theme={themeContext}>{children}</ThemeProvider>
    </RawIntlProvider>
  );
};

export default AppContext;
